<script>
import { typeIcon } from "../js/mapSettings.js";

export default {
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    marker: {
      type: Object,
      required: true
    }
  },
  data() {
      return {
        goodMarker: null,
        contentString:null
      }
    },
  methods:{
    setInfoWindow(){
      this.map.setZoom(24)
      this.map.panTo(this.marker.position);
      this.$emit('click', {
        content: this.contentString,
        anchor: this.goodMarker
      });
    }
  },
  mounted() {
    const { Marker, event, InfoWindow } = this.google.maps;
    const { antenna , permanence } = typeIcon
    const { address , city, state, post_code, country } = this.marker.address
    
    this.contentString =`<p class="font-normal" >${address} <br> ${post_code} ${city} <br> ${state} ${country} </p>`;

    this.goodMarker = new Marker({
      position: this.marker.position,
      animation: google.maps.Animation.DROP,
      marker: this.marker,
      map: this.map,
      icon : {
          url: this.marker.type === 'antenna' ? antenna.icon : permanence.icon , 
          scaledSize: new google.maps.Size(50, 50),
      }
    });    

    // display tooltip on click
    this.goodMarker.addListener('click', () => {
      this.setInfoWindow();
      [...document.querySelectorAll('.js-trigger-marker')].forEach((el)=> {
        el.classList.remove('font-bold')
      });
      let elementList = document.querySelector(`[data-id="${this.marker.id}"]`)
      elementList.classList.add('font-bold')
    });

    event.addListener(this.marker, 'click',  (e) => { 
      this.setInfoWindow();
    });
  },

  render() {}
};
</script>
